import { invalidateRecommendations } from '../recommendations/invalidateRecommendations';

export function onPlaybackStop() {
  invalidateRecommendations();
}
